function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M9.5 8L7 11h1.5L5 14h2.5L3 17h7v4h4v-4h7l-4.5-3H19l-3.5-3H17l-2.5-3H16l-4-6-4 6h1.5z",
  fill: "currentColor"
});

function SvgLocationPark(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    ref: svgRef
  }, props), _ref);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationPark);
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0Ij48ZyBmaWxsPSJjdXJyZW50Q29sb3IiPjxwYXRoIGQ9Ik05LjUgOEw3IDExIDguNSAxMSA1IDE0IDcuNSAxNCAzIDE3IDEwIDE3IDEwIDIxIDE0IDIxIDE0IDE3IDIxIDE3IDE2LjUgMTQgMTkgMTQgMTUuNSAxMSAxNyAxMSAxNC41IDggMTYgOCAxMiAyIDggOCA5LjUgOFoiLz48L2c+PC9zdmc+Cg==";
export { ForwardRef as ReactComponent };